/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {useCallback, useEffect, useMemo, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Link} from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import GroupsIcon from '@mui/icons-material/Groups';
import Container from "@mui/material/Container";

import {useLoginStore} from "../useLoginStore";
import {useApiCallback} from "../util/Api";
import {AuthorityChip} from "./Preferences";


const PersonLink = ({person, navigate}) => (
    <Link color="inherit"
          sx={{lineHeight: '160%', cursor: 'pointer'}}
          onClick={() => navigate(`/person/${person}`)}
    >{person}</Link>
)

export default function GroupInfo() {
    const {email} = useParams()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [groupInfo, setGroupInfo] = useState({})

    const [newMember, setNewMember] = useState('')

    const canUser = useLoginStore(state => state.canUser)
    const canUserSeeGroup = canUser('GET', `/api/group/members/${email}`)
    const canUserAddMembers = canUser('POST', `/api/group/member/${email}`)
    const canUserRemoveMembers = canUser('DELETE', `/api/group/member/${email}`)

    const [members, setMembers] = useState({});
    const getMembers = useApiCallback('GET', `/api/group/members/${email}`, {setLoading, onDone: setMembers})
    useEffect(() => {
        setMembers({})
        if (canUserSeeGroup) getMembers()
    }, [canUserSeeGroup, getMembers]);

    const getGroupInfo = useApiCallback('GET', `/api/group/${email}`, {setLoading, onDone: setGroupInfo})
    useEffect(getGroupInfo, [getGroupInfo]);

    const sorted = useMemo(() => {
        const _ord = ['owner', 'manager', 'member']
        const arr = Object.keys(members)
        arr.sort(
            (a, b) => members[a] === members[b] ? a - b : _ord.indexOf(members[a]) - _ord.indexOf(members[b])
        )
        return arr
    }, [members])

    const addMember = useApiCallback('POST', `/api/group/member/${email}`, {setLoading, onDone: getMembers})
    const removeMember = useApiCallback('DELETE', `/api/group/member/${email}`, {setLoading, onDone: getMembers})

    const reload = useCallback(() => navigate(`/group/${groupInfo.email}`), [navigate, groupInfo]);
    const saveGroup = useApiCallback('POST', `/api/groups/${email}`, {setLoading, onDone: reload})

    if (!groupInfo || !Object.keys(groupInfo).length) {
        return <Container>Group not found.</Container>
    }

    return <Container><Stack sx={{fontSize: {xs: '0.8em', sm: '0.9em', md: '1em'}}}>
        <Box container>
            <Stack direction="row" spacing={2} sx={{alignItems: "center"}}>
                <GroupsIcon sx={{color: 'feature.main', height:100, width:100}}/>
                <Typography variant="h5"><em>Group {groupInfo?.email || email}</em></Typography>
            </Stack>

            <Box mt={3}>
                {!canUserSeeGroup ? 'You do not have permission to view group members' : ''}
                {loading ? 'loading…' : ''}

                {groupInfo?.type === 'Internal' && canUser('POST', `/api/groups/${groupInfo.email}`)
                    ? <Stack direction="row" my={4} alignItems="center" spacing={2}>
                        <TextField
                            label="Name"
                            disabled={loading}
                            InputLabelProps={{shrink: true}}
                            value={groupInfo.name}
                            inputProps={{autoComplete: "none"}}
                            onChange={event => {
                                setGroupInfo({...groupInfo, name: event.target.value})
                            }}
                            sx={{width: '300px', margin: 2}}/>
                        <TextField
                            label="Email"
                            disabled={loading}
                            InputLabelProps={{shrink: true}}
                            value={groupInfo.email}
                            inputProps={{autoComplete: "none"}}
                            onChange={event => {
                                setGroupInfo({...groupInfo, email: event.target.value})
                            }}
                            sx={{width: '300px', margin: 2}}/>
                        <Button
                            onClick={() => saveGroup(groupInfo)}
                        >Save</Button>
                    </Stack>
                    : ''
                }

                {groupInfo?.type === 'Internal' && canUserAddMembers
                    ? (
                        <Stack direction="row" my={4} alignItems="center" spacing={2}>
                            <TextField
                                label="Add member"
                                disabled={loading}
                                InputLabelProps={{shrink: true}}
                                value={newMember}
                                inputProps={{autoComplete:"none"}}
                                onChange={(event) => {
                                    setNewMember(event.target.value)
                                }}
                                sx={{width: '300px', margin: 2}}/>
                            <Button
                                onClick={() => addMember({person: newMember})}
                            >Add Member</Button>
                        </Stack>
                    )
                    : ''
                }

                <Typography variant="h5" mt={3}>Group members</Typography>
                {sorted.length === 0 ? <i>no members</i> : ''}
                {sorted.map(person => (
                    <Stack key={person} direction="row" alignItems="center" spacing={2}>
                        <AuthorityChip authority={members[person]}/>
                        <PersonLink navigate={navigate} person={person}/>
                        {groupInfo?.type === 'Internal' && canUserRemoveMembers
                            ? <Button onClick={() => removeMember({person: person})}>Remove</Button>
                            : ''
                        }
                    </Stack>
                ))}
            </Box>
        </Box>
    </Stack></Container>
}
